import React from 'react'

import { Formik } from 'formik'

import { Modal, Col, Row, Button, Form, Divider } from '_zari/core'
import Yup from '_zari/validation/_yup'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

export const ValidationSchema = Yup.object().shape({
  serieDocumento: Yup.string()
    .required()
    .when('tipoSocio', {
      is: 'C',
      then: Yup.string().matches(/^[0FBfb]/, 'La serie debe iniciar con F, B o 0(cero).')
    })
})

const DocumentosVariosModal = ({
  show,
  handleClose,
  modalData,
  vOrigen,
  submitFunction,
  esAvanzado
}) => {
  const initialFormValues = React.useMemo(() => {
    return {
      ...modalData,
      tipoCambio: modalData.tipoCambio || 1,
      _idSocio: modalData._idSocio || '',
      _idCancelacion: modalData._idCancelacion || '',
      codigoSocio: modalData.codigoSocio || '',
      documentoSocio: modalData.documentoSocio || '',
      nombreSocio: modalData.nombreSocio || '',
      tipoDocumentoSocio: modalData.tipoDocumentoSocio || '',
      tipoSocio: modalData.tipoSocio || 'C',
      tipoRegistro: modalData.tipoRegistro || 'INGR',
      tipoDocumento: modalData.tipoDocumento || '',
      serieDocumento: modalData.serieDocumento || '',
      numeroDocumento: modalData.numeroDocumento || '',
      fechaDocumento: modalData.fechaDocumento || '',
      fechaVencimiento: modalData.fechaVencimiento || ''
    }
  }, [modalData])

  const onSubmit = React.useCallback(
    data => {
      if (data._idCancelacion !== '') {
        data.fechaDocumento = ''
      }

      submitFunction({
        ...data,
        modalValido: true
      })
    },
    [submitFunction]
  )

  return (
    <Modal show={show} centered>
      <Modal.Header>
        <Modal.Title>{esAvanzado ? 'EDICION AVANZADA' : 'DOCUMENTOS VARIOS'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={initialFormValues} onSubmit={onSubmit}>
        {({
          errors,
          touched,
          isSubmitting,
          values,
          handleChange,
          handleSubmit,
          setValues,
          setFieldValue
        }) => (
          <>
            <Modal.Body>
              <Form>
                {esAvanzado && (
                  <Sections.ComunSection
                    errors={errors}
                    touched={touched}
                    isSubmitting={isSubmitting}
                    handleChange={handleChange}
                    values={values}
                    setFieldValue={setFieldValue}
                    setValues={setValues}
                    nextNodeId='input-tipoDocumento'
                  />
                )}
                <Row>
                  <Col md={4}>
                    <FormGroups.TipoSocioFormGroup
                      iError={errors.tipoSocio}
                      iTouched={touched.tipoSocio}
                    />
                  </Col>
                  <Col md={8}>
                    <FormGroups.SocioFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idSocio}
                      iTouched={touched._idSocio}
                      iValue={values._idSocio}
                      values={values}
                      setValues={setValues}
                      vTipoSocio={values.tipoSocio}
                    />
                  </Col>
                </Row>
                <FormGroups.TipoRegistroFormGroup iValue={values.tipoRegistro} />
                <Divider />
                <Sections.IngresoSection
                  errors={errors}
                  handleChange={handleChange}
                  isSubmitting={isSubmitting}
                  setFieldValue={setFieldValue}
                  touched={touched}
                  vOrigen={vOrigen}
                  values={values}
                />
                {values.tipoRegistro === 'BUSQ' ? (
                  <Sections.CancelacionSection
                    idSocio={values._idSocio}
                    iValue={values._idCancelacion}
                    handleChange={handleChange}
                    values={values}
                    setValues={setValues}
                    vOrigen={vOrigen}
                  />
                ) : null}
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button
                id='button-cajabancomodal-procesar'
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                Guardar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(DocumentosVariosModal)
